import { DefaultValue } from 'app/components/access-panel/default-values/panel-default-values-utils';
import { sortByDescriptionAscending } from 'app/infrastructure/data/sort';

export const sortDefaultValues = (values: DefaultValue[]): DefaultValue[] =>
  [...(values ?? [])]
    .map(value => ({
      ...value,
      defaultValueFields: sortByDescriptionAscending(value.defaultValueFields)
    }))
    .sort((a, b) =>
      ((a?.optionsColection?.description ?? '') + (a?.caseType?.description ?? '') + (a?.defaultValueFields?.[0]?.description ?? ''))
        .localeCompare(
          (b?.optionsColection?.description ?? '') + (b?.caseType?.description ?? '') + (b?.defaultValueFields?.[0]?.description ?? ''))
    );
